import { useLocationTrackingParams } from "../providers/LocationTrackingContextProvider";
import { useRef } from "react";
import {
  AnalyticsService as analytics,
  AnalyticsTrackingEvent,
} from "@brandclub/common-ui";

const AnalyticsService = {
  track: (
    eventName: AnalyticsTrackingEvent,
    data: any,
    options: {
      sendImmediately?: boolean;
    }
  ) => {
    return analytics.track(eventName, data, options).catch((error: any) => {
      console.error("Error tracking event", error);
    });
    // alert('track ' + JSON.stringify({ eventName, data }, null, 2));
  },
};

interface AdditionalData {
  [key: string]: any;
}
/**
 * useTrackView tracks view once when the component mounts and doesn't track again on re-renders.
 */
export const useTrackViewEvent = (eventName: AnalyticsTrackingEvent) => {
  const [trackingParams] = useLocationTrackingParams();
  const hasTrackedView = useRef(false); // Use ref to track if the view has been tracked
  return (
    additionalData: AdditionalData,
    options: {
      sendImmediately?: boolean;
    }
  ) => {
    if (!hasTrackedView.current && trackingParams) {
      hasTrackedView.current = true;
      return AnalyticsService.track(
        eventName,
        {
          ...additionalData,
          ...trackingParams,
        },
        options
      );
    }
  };
};

export const useTrackActions = () => {
  const [trackingParams] = useLocationTrackingParams();
  const additionDataRef = useRef<AdditionalData>({});
  return [
    async (
      eventName: AnalyticsTrackingEvent,
      additionalData: AdditionalData = {},
      options: {
        sendImmediately?: boolean;
      } = {}
    ) => {
      return AnalyticsService.track(
        eventName,
        {
          ...trackingParams,
          ...additionDataRef.current,
          ...additionalData,
        },
        {
          sendImmediately: options.sendImmediately,
        }
      );
    },
    (additionData: AdditionalData) => {
      additionDataRef.current = { ...additionDataRef.current, ...additionData };
    },
  ] as const;
};
